import { EventData, venueType } from "../models/event";

export const isYetToBeAnnounced = (value: unknown) =>
  value === true || value === 1 || value === "1" || value === "true";

export const hasFullVenueAddress = (venue: venueType | null | undefined) =>
  Boolean(
    venue?.place_id?.trim() &&
      venue?.lat?.trim() &&
      venue?.lng?.trim() &&
      venue?.line1?.trim() &&
      venue?.name?.trim(),
  );

export const citiesMatch = (a?: string | null, b?: string | null) =>
  Boolean(a?.trim() && b?.trim() && a.trim().toLowerCase() === b.trim().toLowerCase());

export const tbdCityLockedStorageKey = (eventId: string) =>
  `event-tbd-city-${eventId}`;

export const getTbdCityLockedInStorage = (eventId?: string): string | null => {
  if (!eventId) return null;
  return localStorage.getItem(tbdCityLockedStorageKey(eventId));
};

export const setTbdCityLockedInStorage = (eventId: string, city: string) => {
  localStorage.setItem(tbdCityLockedStorageKey(eventId), city);
};

const emptyVenueFields = (): Omit<venueType, "name" | "city"> => ({
  place_id: "",
  lat: "",
  lng: "",
  line1: "",
  line2: "",
  state: "",
  postal: "",
  type: "",
  country: "",
});

/** Normalize venue from nested object, flat form fields, or plain string. */
export function resolveVenueFromEvent(
  event: Pick<EventData, "venue"> & {
    venue_name?: string;
    line1?: string;
    line2?: string;
    city?: string;
  },
): venueType | null {
  const { venue } = event;

  if (venue && typeof venue === "object") {
    return venue;
  }

  if (typeof venue === "string" && venue.trim()) {
    return {
      name: venue.trim(),
      city: venue.trim(),
      ...emptyVenueFields(),
    };
  }

  const { venue_name, line1, line2, city } = event;
  if (venue_name?.trim() || line1?.trim() || city?.trim()) {
    return {
      ...emptyVenueFields(),
      name: venue_name?.trim() || city?.trim() || "",
      city: city?.trim() || "",
      line1: line1?.trim() || "",
      line2: line2?.trim() || "",
    };
  }

  return null;
}

export function mergeVenueFromSave(
  apiVenue: EventData["venue"],
  savedVenue: EventData["venue"],
): venueType | undefined {
  if (apiVenue && typeof apiVenue === "object") {
    return apiVenue;
  }
  if (savedVenue && typeof savedVenue === "object") {
    return savedVenue;
  }
  return undefined;
}

export function syncVenueFormFields(
  form: { setFieldsValue: (values: Record<string, unknown>) => void },
  venue: venueType | null | undefined,
  lockedCity?: string | null,
) {
  form.setFieldsValue({
    venue_name: venue?.name || undefined,
    line1: venue?.line1 || undefined,
    line2: venue?.line2 || undefined,
    city: lockedCity || venue?.city || undefined,
  });
}

export function resolveLockedTbdCity(
  eventId: string | undefined,
  yetTbd: boolean,
  venue: venueType | null,
): string | null {
  const storedCity = getTbdCityLockedInStorage(eventId);
  if (storedCity) return storedCity;
  if (yetTbd && venue?.city) return venue.city;
  return null;
}
